import styled from 'styled-components';

export const StyledVehicleDetailIcon = styled.svg`
    display: block;
`;
